@if (parentElement && elements?.length) {
  <nav class="navbar navbar-expand p-0 bg-white shadow-sm mw-xs-xl-1280p" role="navigation">
    <div class="container-fluid px-3">
      <div class="collapse navbar-collapse px-md-3">
        @if (showOrderListsViewTypeSwitch()) {
          <app-order-lists-view-type-switch />
        }

        <ul class="navbar-nav nav-pills nav flex-grow-1">
          @for (element of elements; track element.id) {
            <li class="nav-item">
              @if (element.isDropdown) {
                <a class="btn nav-link no-outline"
                  [class.active]="element === selectedElement"
                  (click)="onDropdownClick(element, $event)"
                >
                  {{ element.title | translate }}
                </a>
              }
              @else if (element.externalPathTarget?.length) {
                <a class="btn nav-link no-outline"
                  [href]="element.externalPath"
                  [target]="element.externalPathTarget ?? '_self'"
                  [class.active]="element === selectedElement"
                  (click)="onNavbarClose()"
                >
                  {{ element.title | translate }}
                </a>
              }
              @else {
                <a class="btn nav-link no-outline"
                  [routerLink]="`${topLevelUrlPath}/${element.path}`"
                  [class.active]="element === selectedElement"
                  (click)="onNavbarClose()"
                >
                  {{ element.title | translate }}
                </a>
              }
            </li>
          }
        </ul>
        @if (showSearch()) {
          <app-navigation-search-input />
        }
      </div>
    </div>
  </nav>
}
